import { Moment } from 'moment-timezone'
import React from 'react'
import Trns from 'src/localization/Trns'
import { RecurrenceTerminator } from 'src/models/recurrence.models'

interface RecurrenceEndingLabelProps {
  className?: string
  terminator: RecurrenceTerminator
  count?: number
  untilMoment?: Moment
}

const RecurrenceEndingLabel: React.FC<RecurrenceEndingLabelProps> = (
  props,
): React.ReactElement => {
  switch (props.terminator) {
    case RecurrenceTerminator.Count: {
      return props.count === 1 ? (
        <Trns source={'Ends after 1 reset'} />
      ) : (
        <Trns
          source={'Ends after ${count} resets'}
          expressions={{
            count: `${props.count}`,
          }}
        />
      )
    }
    case RecurrenceTerminator.Date: {
      return (
        <Trns
          source={'until ${date}'}
          expressions={{
            date: props.untilMoment?.format('l') || '',
          }}
        />
      )
    }
    case RecurrenceTerminator.None: {
      return <Trns source={'forever'} />
    }
    default: {
      return <Trns source={'Unknown'} />
    }
  }
}

export default RecurrenceEndingLabel
